
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M22.38 0A2.63 2.63 0 0125 2.63v10.16a2.63 2.63 0 01-2.62 2.62H12.22a2.63 2.63 0 01-2.63-2.62V2.63A2.63 2.63 0 0112.22 0h10.16zm0 .75H12.22a1.88 1.88 0 00-1.87 1.88v10.16a1.88 1.88 0 001.88 1.88h10.15a1.88 1.88 0 001.88-1.87V2.63A1.88 1.88 0 0022.38.75zM8.53 2.22a.38.38 0 010 .75H1.59a.9.9 0 00-.84 1v7.53a.9.9 0 00.84 1h6.94a.38.38 0 010 .75v-.05H1.59A1.65 1.65 0 010 11.5V3.92a1.65 1.65 0 011.59-1.7h6.94zm24.64-.05a1.65 1.65 0 011.59 1.7v7.63a1.65 1.65 0 01-1.58 1.7h-6.95a.38.38 0 010-.75h6.94a.9.9 0 00.84-1V3.92a.9.9 0 00-.84-1h-6.94a.38.38 0 010-.75h6.94zM15.59 3.38l5.37 4A.38.38 0 0121 8l-5.26 4a.37.37 0 01-.27.06.38.38 0 01-.37-.37l-.11-8a.37.37 0 01.6-.31zm.15 1.1l.09 6.46L20.1 7.7l-4.36-3.22zm14.87 1.06l1.94 1.88a.37.37 0 010 .53l-1.9 1.9a.37.37 0 01-.26.15.37.37 0 01-.27-.64l1.63-1.66-1.66-1.62a.375.375 0 01.52-.54zm-1.97 0l1.94 1.88a.37.37 0 01.11.27.38.38 0 01-.11.27l-1.9 1.9a.37.37 0 01-.26.14.38.38 0 01-.27-.64l1.63-1.66-1.66-1.62a.375.375 0 01.52-.54zM4.832 5.453A.375.375 0 015 6.08L3.33 7.7 5 9.33a.38.38 0 01-.27.64l-.04.03a.37.37 0 01-.27-.11L2.53 8a.38.38 0 01-.11-.27.37.37 0 01.11-.27l1.94-1.91a.375.375 0 01.362-.097zm2.153.082c.155.146.161.39.015.545L5.3 7.7l1.63 1.63a.38.38 0 01-.27.64V10a.37.37 0 01-.27-.11L4.5 8a.38.38 0 01-.11-.27.37.37 0 01.11-.27l1.94-1.91a.386.386 0 01.545-.015z"}})])
          )
        }
      }
    